const BORDER = "hsl(215 20% 25%)";

export const selectStyles = {
  // From elements
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "transparent",
    borderColor: BORDER,
    borderRadius: "6px",
    padding: "2px",
    boxShadow: "0 0 0 0",
    opacity: state.isDisabled ? 0.5 : 1,
    "&:hover": {
      borderColor: BORDER,
    },
  }),
  input: (provided: any) => ({
    ...provided,
    fontSize: "14px",
    color: "#94a3b8",
  }),

  // Form menu
  menu: (provided: any) => ({
    ...provided,
    fontSize: "14px",
    backgroundColor: "hsl(223, 30%, 17%)",
  }),
  menuPortal: (privded: any) => ({
    ...privded,
    zIndex: 99,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "transparent",
    color: state.isSelected ? "hsl(215 75% 60%)" : "currentColor",
    "&:active": {
      backgroundColor: "hsl(223, 30%, 20%)",
    },
    "&:hover": {
      backgroundColor: "hsl(223, 25%, 20%)",
    },
  }),

  // Form Values
  placeholder: (provided: any, state: any) => ({
    ...provided,
    fontSize: "14px",
    color: "currentColor",
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,
    fontSize: "14px",
    color: "currentColor",
  }),
  multiValue: (provided: any) => ({
    ...provided,
    backgroundColor: "hsl(220 30% 25%)",
    margin: "0",
    padding: "0",
    borderRadius: "5px",
    ":not(:first-of-type)": {
      marginLeft: "8px",
    },
  }),
  multiValueLabel: (provided: any) => ({
    ...provided,
    color: "hsl(215 10% 75%)",
    padding: "4px 8px",
    fontSize: "12px",
  }),
  multiValueRemove: (provided: any) => ({
    ...provided,
    backgroundColor: "hsl(220 30% 20%)",
    color: "hsl(215 0% 60%)",
    "&:hover": {
      backgroundColor: "hsl(220 30% 40%)",
      color: "hsl(215 0% 80%)",
    },
  }),

  // Form indicators
  indicatorSeparator: (provided: any) => ({
    ...provided,
    border: `1px solid ${BORDER}`,
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    "&:hover": {
      color: "hsl(215 25% 35%)",
    },
  }),
  clearIndicator: (provided: any, state: any) => ({
    ...provided,
    "&:hover": {
      color: "hsl(215 25% 35%)",
    },
  }),
};
